
import { computed, defineComponent } from 'vue';

import Box, { BoxColor, BoxColorVariant, ColorProps } from '@/elements/box/Box';

import { HeaderProps } from './Header.types';

export default defineComponent({
  name: 'Header',
  components: { Box },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String as () => BoxColor,
      default: 'white',
    },
    variant: {
      type: String as () => BoxColorVariant,
      default: 'neutral',
    },
  },
  setup(props: HeaderProps & ColorProps, { slots, emit }) {
    const hasMenu = slots.menu !== undefined;

    const buttonClasses = computed(() => {
      const classMap = new Map([
        ['white', []],
        [
          'cyan',
          [
            'hover:bg-cyan-300',
            'focus:bg-cyan-300',
            'focus:ring-offset-cyan-500',
          ],
        ],
        [
          'gray',
          [
            'hover:bg-gray-400',
            'focus:bg-gray-400',
            'focus:ring-offset-gray-500',
          ],
        ],
        [
          'orange',
          [
            'hover:bg-orange-400',
            'focus:bg-orange-400',
            'focus:ring-offset-orange-500',
          ],
        ],
        [
          'blue',
          [
            'hover:bg-blue-400',
            'focus:bg-blue-400',
            'focus:ring-offset-blue-500',
          ],
        ],
      ]);

      return classMap.get(props.color);
    });

    const handleToggle = () => {
      emit('toggle');
    };

    return {
      hasMenu,
      buttonClasses,
      handleToggle,
    };
  },
});
